import {Typography} from '@mui/material';

export const PrivacyPolicy = () => {
  return (
    <Typography textAlign="center" variant="h1">
      Privacy Policy
    </Typography>
  );
};
